import { z } from 'zod';
export const SkipValid = z.any();
